import React from 'react'
import { openPopup } from '../../../store/popupSlice';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

export default function OnDemandGlobal() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="ondemand-global-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ondemand-global-box">
                <div className="row">
                  <div className="col-lg-7">
                    <h3 className="heading">Mobility Infotech powers growth for 500+ global businesses with on-demand solutions.</h3>
                    <ul>
                      <li>Enterprise-grade security</li>
                      <li>Seamless scalability & updates</li>
                      <li>24/7 expert assistance</li>
                    </ul>
                    <Link onClick={() => dispatch(openPopup())} className="default-btn default-white">Start Building</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
